<template>
  <div>
    <MenuDocument/>
    <Document_reduce_debt/>
  </div>
</template>

<script>
import MenuDocument from "@/components/admin/document_stock/menudocument/MenuDocument";
import Document_reduce_debt from "@/components/admin/document_stock/Document_reduce_debt";
export default {
  name: "DocumentReduceDebt",
  components: {
    Document_reduce_debt,
    MenuDocument
  }
}
</script>

<style scoped>

</style>
